export default "__VITE_ASSET__DPoEF0t5__"